import { useLenis } from "lenis/react";
import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { LOGO_URL } from "@/data/content";

export default function Footer() {
  const lenis = useLenis();
  const toTop = () => {
    if (lenis) lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="relative border-t border-white/10 bg-black px-5 sm:px-8 lg:px-12 py-14" data-testid="footer">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Vision Studio" className="h-10 w-auto object-contain" />
            <span className="font-display text-sm font-semibold tracking-[0.3em] text-white uppercase">
              Vision Studio
            </span>
          </div>

          <p className="max-w-sm text-sm font-light leading-relaxed text-zinc-500">
            We sculpt with light and shadow. Concept, design, rigging and previs
            for shows that live long after the last cue.
          </p>

          <button
            onClick={toTop}
            data-testid="back-to-top"
            className="group inline-flex items-center gap-3 self-start text-xs font-semibold uppercase tracking-[0.2em] text-zinc-400 hover:text-white transition-colors"
          >
            Back to top
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-white/20 transition-all duration-300 group-hover:bg-white group-hover:text-black">
              <ArrowUp className="h-4 w-4" />
            </span>
          </button>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-zinc-600 sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} Vision Studio. All rights reserved.</span>
          <div className="flex items-center gap-5">
            <Link
              to="/privacy"
              data-testid="footer-privacy"
              className="uppercase tracking-[0.2em] text-zinc-500 hover:text-white transition-colors"
            >
              Privacy
            </Link>
            <span className="uppercase tracking-[0.2em]">Lighting · Stage · Rigging · Previs</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
